import styled from 'styled-components';
import {Drawer} from 'antd';

const StyledEditBudgetModal = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    button {
      margin-inline-end: 0;
      margin-inline-start: 12px;
    }
  }

  .ant-drawer-footer {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    padding: 16px 24px;
  }
`;


export {StyledEditBudgetModal};
